(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('prepaidRefillPageCTN', function() {
    return function (ctn) {
      if (!ctn) { return ''; }

      var value = ctn.toString().trim().replace(/^\+/, '');

      if (value.match(/[^0-9]/)) {
        return ctn;
      }
      switch (value.length) {
        case 10:
          return (value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 10)).trim();
          break;
        case 9:
          return (value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9)).trim();
          break;
        default:
          return ctn;
      }
    };

  });

})();

